import { __assign, __rest } from "tslib";
import React from 'react';
import { Box } from '@marvelapp/ui';
export default function EmptyStateWrapper(_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(Box, __assign({ alignItems: "center", border: "1px dashed", borderColor: "smoke", borderRadius: 1, display: "flex", flex: "1", flexDirection: "column", justifyContent: "center", px: 4, py: 6 }, props), children));
}
